import { appQueryParameters } from '@clubmed/utils';

import { ICONS } from 'Components/utils/icon/icons';

export const ADULTS_ONLY_FACET_ID = 'facette_adult_only';
export const ADULTS_NUMBER_MIN = 1;
export const MAX_PAX = 6;
export const MAX_PAX_SELLER = 8;
export const AREA_FACET_PREFIX_ID = 'AREA';
export const CHILDCARE_CRITERIA_FACET_ID = 'facette_childcare_age_in_month';
export const CHILDCARE_FILTER_FACET_ID = 'facette_childcare_age_in_month_list';
export const COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
export const DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
export const DEPARTURE_DATE = 'date';
export const DEPARTURE_DATE_MAX_DATE = {
  years: 2,
};
export const DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
export const DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
export const DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
export const DURATION_FACET = 'facette_duration';
export const KIDS_FACET_ID = 'facette_kids';
export const KIDS_NUMBER_MAX = 5;
export const KIDS_NUMBER_MAX_SELLER = 7;
export const LOCALE_FACET_ID = 'locale';
export const MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
export const OFFER_ID_FACET_ID = 'facette_offer_id';
export const PRODUCT_FACET_ID = 'product_id';
export const WHEN_FACET_ID = 'facette_when';
export const WHERE_FACET_ID = 'facette_where';
export const ACTIVITIES_FACET_ID = 'activities_tree';
export const DESTINATIONS_FACET_ID = 'destinations_tree';
export const COUNTRIES_FACET_ID = 'facette_destination_country';
export const SEASON_FACET_ID = 'seasons_ns';
export const TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
export const TYPES_OF_STAY_FACET_ID = 'facette_types';
export const FLIGHT_DURATION_FACET_ID = 'facette_flight_duration';
export const QUERY_QUERY_PARAM = 'search';
export const SORT_BY_PRICE_QUERY_PARAM = 'sortByPrice';
export const PRODUCTS_TO_COMPARE_QUERY_PARAM = appQueryParameters.productsComparison.productIds;
export const FACET_QUERY_PARAMS = [
  { id: 'destination', facetId: COUNTRIES_FACET_ID },
  { id: 'departure_city', facetId: DEPARTURE_CITY_FACET_ID },
];
export const DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];

export const FILTERABLE_FACETS_IDS = [
  ACTIVITIES_FACET_ID,
  CHILDCARE_FILTER_FACET_ID,
  COUNTRIES_FACET_ID,
  DESTINATIONS_FACET_ID,
  SEASON_FACET_ID,
  TYPES_OF_STAY_FACET_ID,
];

export const CUSTOM_FACETS_IDS = [FLIGHT_DURATION_FACET_ID];

export const FILTERABLE_FACETS_TRACKING_CONFIG = [
  {
    id: ACTIVITIES_FACET_ID,
    trackingPrefixLabel: 'activities',
  },
  {
    id: CHILDCARE_FILTER_FACET_ID,
    trackingPrefixLabel: 'childcare',
  },
  {
    id: DESTINATIONS_FACET_ID,
    trackingPrefixLabel: 'destinations',
  },
  {
    id: COUNTRIES_FACET_ID,
    trackingPrefixLabel: 'destinations',
  },
  {
    id: FLIGHT_DURATION_FACET_ID,
    trackingPrefixLabel: 'flightDuration',
  },
  {
    id: SEASON_FACET_ID,
    trackingPrefixLabel: 'season',
  },
  {
    id: TYPES_OF_STAY_FACET_ID,
    trackingPrefixLabel: 'typeofstay',
  },
];

export const GROUP_STRING = 'group::';

export const CHILDCARE_FILTER_FACET_OPTION_0_TO_2 = `${GROUP_STRING}from_0_to_2`;
export const CHILDCARE_FILTER_FACET_OPTION_2_TO_3 = `${GROUP_STRING}from_2_to_3`;
export const CHILDCARE_FILTER_FACET_OPTION_4_TO_10 = `${GROUP_STRING}from_4_to_10`;
export const CHILDCARE_FILTER_FACET_OPTION_11_TO_17 = `${GROUP_STRING}from_11_to_17`;

export const CHILDCARE_FILTER_FACET_LABELS_PREFIX = 'faceting.filters.childcare.label_';

export const CHILDCARE_FILTER_FACET_LABELS = {
  from_0_to_2: `${CHILDCARE_FILTER_FACET_LABELS_PREFIX}babyClub`,
  from_2_to_3: `${CHILDCARE_FILTER_FACET_LABELS_PREFIX}miniClub`,
  from_4_to_10: `${CHILDCARE_FILTER_FACET_LABELS_PREFIX}petitClub`,
  from_11_to_17: `${CHILDCARE_FILTER_FACET_LABELS_PREFIX}teenClub`,
};

export const CHILDCARE_FILTER_FACET_AVERAGE_MONTHS = {
  from_0_to_2: 12,
  from_2_to_3: 30,
  from_4_to_10: 84,
  from_11_to_17: 168,
};

export const FLIGHT_DURATION_FACET_LABELS_PREFIX = 'faceting.filters.flightDuration.label_';

export const FLIGHT_DURATION_FACET_LABELS = {
  '2h': `${FLIGHT_DURATION_FACET_LABELS_PREFIX}2h`,
  '4h': `${FLIGHT_DURATION_FACET_LABELS_PREFIX}4h`,
  '8h': `${FLIGHT_DURATION_FACET_LABELS_PREFIX}8h`,
  '8hmore': `${FLIGHT_DURATION_FACET_LABELS_PREFIX}8h_more`,
};

export const FLIGHT_DURATION_FACET_AS_LIST = {
  id: FLIGHT_DURATION_FACET_ID,
  name: FLIGHT_DURATION_FACET_ID,
  list: [
    {
      label: '2h',
      value: '2h',
      count: -1,
    },
    {
      label: '4h',
      value: '4h',
      count: -1,
    },
    {
      label: '8h',
      value: '8h',
      count: -1,
    },
    {
      label: '8hmore',
      value: '8hmore',
      count: -1,
    },
  ],
};

export const SEASON_FACET_FIRST_OPTION = 'SOLEIL';

export const SEASON_FACET_LABELS_PREFIX = 'faceting.filters.season.label_';

export const SEASON_FACET_LABELS = {
  NEIGE: `${SEASON_FACET_LABELS_PREFIX}snow`,
  SOLEIL: `${SEASON_FACET_LABELS_PREFIX}sun`,
};

export const SEASON_FACET_QUERY_PARAM_FR_TO_EN = {
  NEIGE: 'SNOW',
  SOLEIL: 'SUN',
};

export const SEASON_FACET_QUERY_PARAM_EN_TO_FR = {
  SNOW: 'NEIGE',
  SUN: 'SOLEIL',
};

export const NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES = ['CRUISE', 'JOYVIEW', 'TOUR'];

export const TYPES_OF_STAY_FACET_BADGE_ICON_PROPS = {
  3: {
    className: 'rounded-4 size-40',
    iconName: ICONS.TRIDENT3,
  },
  4: {
    className: 'rounded-4 size-40',
    iconName: ICONS.TRIDENT4,
  },
  5: {
    className: 'rounded-4 size-40 bg-ultramarine border-ultramarine text-white',
    iconName: ICONS.DIAMOND,
  },
  6: {
    className: 'rounded-4 size-40 bg-ultramarine border-ultramarine text-white',
    iconName: ICONS.TRIDENT6,
  },
  CRUISE: {
    className: 'rounded-4 size-40 bg-sienna border-sienna text-white',
    iconName: ICONS.CRUISE,
  },
  JOYVIEW: {
    className: 'rounded-4 size-40 bg-blueWave border-blueWave text-white',
    iconName: ICONS.TRIDENT_JOYVIEW,
  },
  TOUR: {
    className: 'rounded-4 size-40 bg-sienna border-sienna text-white',
    iconName: ICONS.TOUR,
  },
};

export const TYPES_OF_STAY_FACET_LABELS_PREFIX = 'faceting.filters.typesOfStay.label_';

export const TYPES_OF_STAY_FACET_LABELS = {
  3: `${TYPES_OF_STAY_FACET_LABELS_PREFIX}3_tridents`,
  4: `${TYPES_OF_STAY_FACET_LABELS_PREFIX}4_tridents`,
  5: `${TYPES_OF_STAY_FACET_LABELS_PREFIX}exclusive_collection`,
  6: `${TYPES_OF_STAY_FACET_LABELS_PREFIX}villa`,
  CRUISE: `${TYPES_OF_STAY_FACET_LABELS_PREFIX}cruise`,
  JOYVIEW: `${TYPES_OF_STAY_FACET_LABELS_PREFIX}joyview`,
  TOUR: `${TYPES_OF_STAY_FACET_LABELS_PREFIX}tour`,
};

export const FILTERABLE_FACETS_TEMPLATE_CONFIG = [
  {
    id: DESTINATIONS_FACET_ID,
    dataLabel: 'where',
    facetLists: [
      {
        deep: false,
        id: DESTINATIONS_FACET_ID,
        titleLabel: 'faceting.filters.where.destinationTitle',
      },
      {
        deep: false,
        id: COUNTRIES_FACET_ID,
        titleLabel: 'faceting.filters.where.countriesTitle',
      },
    ],
    titleLabel: 'faceting.filters.where.title',
  },
  {
    id: ACTIVITIES_FACET_ID,
    dataLabel: 'activities',
    facetLists: [{ deep: true, id: ACTIVITIES_FACET_ID }],
    titleLabel: 'faceting.filters.activities.title',
  },
  {
    id: CHILDCARE_FILTER_FACET_ID,
    dataLabel: 'childcare',
    facetLists: [
      {
        deep: false,
        id: CHILDCARE_FILTER_FACET_ID,
        facetLabels: CHILDCARE_FILTER_FACET_LABELS,
      },
    ],
    titleLabel: 'faceting.filters.childcare.title',
    trackingPrefixLabel: 'childcare',
  },
  {
    id: TYPES_OF_STAY_FACET_ID,
    dataLabel: 'typeofstay',
    facetLists: [
      {
        deep: false,
        id: TYPES_OF_STAY_FACET_ID,
        facetLabels: TYPES_OF_STAY_FACET_LABELS,
      },
    ],
    titleLabel: 'faceting.filters.typesOfStay.title',
    trackingPrefixLabel: 'typeofstay',
  },
  {
    id: FLIGHT_DURATION_FACET_ID,
    dataLabel: 'flightDuration',
    facetLists: [
      {
        deep: false,
        id: FLIGHT_DURATION_FACET_ID,
        facetLabels: FLIGHT_DURATION_FACET_LABELS,
      },
    ],
    titleLabel: 'faceting.filters.flightDuration.title',
    trackingPrefixLabel: 'flightDuration',
  },
  {
    id: SEASON_FACET_ID,
    capitalizeLabels: true,
    dataLabel: 'season',
    facetLists: [
      {
        deep: false,
        id: SEASON_FACET_ID,
        facetLabels: SEASON_FACET_LABELS,
      },
    ],
    titleLabel: 'faceting.filters.season.title',
    trackingPrefixLabel: 'season',
  },
];

export const FACETS = {
  when: 'when',
  who: 'who',
  where: 'where',
};
